import React, { useContext, useEffect, useState } from "react";
import { UserContext } from '../common/UserContext';
import config from "../../envconfig";
import { ToastContainer, toast } from 'react-toastify';
import { Modal } from "react-bootstrap";

const Widget = ({ showModal, setShowModal, onWidgetChange = () => { } }) => {
    const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId, UM_UserType } = useContext(UserContext);
    const [roles, setRoles] = useState([]);
    const [isAdmin, setisAdmin] = useState(false);
    const [checkedCount, setCheckedCount] = useState(0);
    const [widgetDetails, setWidgetDetails] = useState([]);

    const fetchWidgetDetails = async () => {
        try {
            const response = await fetch(`${config.API_URL}/getWidgetsByUserId/${UM_UserId}`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            setWidgetDetails(data);

            console.log("WIDGET DATA GET WID BY", data)
            const countOnes = (data) => {
                let count = 0;
                data.forEach(item => {
                    count += [item.Widget_Inventory, item.Widget_Logistic, item.Widget_Order, item.Widget_Routing, item.Widget_Scp, item.Widget_Shipment, item.Widget_User]
                        .filter(value => value === 1).length;
                });
                return count;
            };
            const numberOfOnes = countOnes(data);
            console.log('Number of 1s:', numberOfOnes);
            setCheckedCount(numberOfOnes)
        } catch (err) {
            console.log(err)
        }
    };

    useEffect(() => {
        const fetchRolesByUserId = async () => {
            try {
                const response = await fetch(`${config.API_URL}/getRolesByUserId/${UM_UserId}`);
                console.log(response);
                const data = await response.json();
                console.log("getRolesByUserId data--------", data)
                setisAdmin(parseInt(UM_UserType) === 1);
                setRoles(data);
            } catch (error) {
                console.error('Error fetching roles:', error);
            }
        };

        fetchRolesByUserId();
    }, [UM_UserId]);

    useEffect(() => {
        fetchWidgetDetails();
    }, [UM_UserId]);

    // Handle checkbox change event
    const handleCheckboxChange = (event) => {
        const isChecked = event.target.checked;
        const columnId = event.target.id;
        console.log("IS CHECKED - ", isChecked)
        console.log("COLUMN - ", columnId)

        if (isChecked && checkedCount >= 4) {
            toast.error('You can only select up to 4 widgets.');
            event.target.checked = false;
        } else {
            setWidgetDetails(prevDetails => {
                if (prevDetails.length === 0) {
                    return prevDetails;
                }

                const updatedDetails = prevDetails.map(detail => ({
                    ...detail,
                    [columnId]: isChecked ? 1 : 0
                }));

                const data = {
                    Widget_UserId: UM_UserId,
                    ColumnName: columnId,
                    Value: isChecked ? 1 : 0
                };

                fetch(`${config.API_URL}/update-widget`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(data),
                })
                    .then(response => response.json())
                    .then(data => {
                        console.log('Success:', data);
                        // Call the callback to refresh dashboard
                        onWidgetChange();
                    })
                    .catch(error => {
                        console.error('Error:', error);
                    });

                return updatedDetails;
            });

            setCheckedCount(prevCount => prevCount + (isChecked ? 1 : -1));
        }
    };

    // Handle modal close
    const handleClose = () => {
        setShowModal(false);
        // Call the callback to refresh dashboard without full page reload
        onWidgetChange();
    };

    // Function to generate checkboxes based on roles
    const renderRoleBasedItems = () => {
        const widgetDetail = widgetDetails[0] || {};

        const adminItems = (
            <>
                <tr>
                    <td><label htmlFor="Widget_Order">Orders</label></td>
                    <td>
                        <input
                            type="checkbox"
                            id="Widget_Order"
                            onChange={handleCheckboxChange}
                            checked={widgetDetail.Widget_Order === 1}
                        />
                    </td>
                </tr>
                <tr>
                    <td><label htmlFor="Widget_Shipment">Shipment</label></td>
                    <td>
                        <input
                            type="checkbox"
                            id="Widget_Shipment"
                            onChange={handleCheckboxChange}
                            checked={widgetDetail.Widget_Shipment === 1}
                        />
                    </td>
                </tr>
                <tr>
                    <td><label htmlFor="Widget_User">User</label></td>
                    <td>
                        <input
                            type="checkbox"
                            id="Widget_User"
                            onChange={handleCheckboxChange}
                            checked={widgetDetail.Widget_User === 1}
                        />
                    </td>
                </tr>
                <tr>
                    <td><label htmlFor="Widget_Scp">SCP</label></td>
                    <td>
                        <input
                            type="checkbox"
                            id="Widget_Scp"
                            onChange={handleCheckboxChange}
                            checked={widgetDetail.Widget_Scp === 1}
                        />
                    </td>
                </tr>
            </>
        );

        const roleBasedItems = roles.map((role, index) => {
            if (role.RLM_SubMenuOptions.includes("Order Master (by SCP)")) {
                return (
                    <tr key={`orders-${index}`}>
                        <td><label htmlFor={`orders-checkbox-${index}`}>Orders</label></td>
                        <td>
                            <input
                                type="checkbox"
                                id="Widget_Order"
                                onChange={handleCheckboxChange}
                                checked={widgetDetail.Widget_Order === 1}
                            />
                        </td>
                    </tr>
                );
            }
            if (role.RLM_SubMenuOptions.includes("Shipment Master")) {
                return (
                    <React.Fragment key={`shipment-${index}`}>
                        <tr>
                            <td><label htmlFor={`shipment-checkbox-${index}`}>Shipment</label></td>
                            <td>
                                <input
                                    type="checkbox"
                                    id="Widget_Shipment"
                                    onChange={handleCheckboxChange}
                                    checked={widgetDetail.Widget_Shipment === 1}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td><label htmlFor={`inventory-checkbox-${index}`}>Inventory</label></td>
                            <td>
                                <input
                                    type="checkbox"
                                    id="Widget_Inventory"
                                    onChange={handleCheckboxChange}
                                    checked={widgetDetail.Widget_Inventory === 1}
                                />
                            </td>
                        </tr>
                    </React.Fragment>
                );
            }
            if (role.RLM_SubMenuOptions.includes("Route Master")) {
                return (
                    <tr key={`routing-${index}`}>
                        <td><label htmlFor={`routing-checkbox-${index}`}>Route</label></td>
                        <td>
                            <input
                                type="checkbox"
                                id="Widget_Routing"
                                onChange={handleCheckboxChange}
                                checked={widgetDetail.Widget_Routing === 1}
                            />
                        </td>
                    </tr>
                );
            }
            if (role.RLM_SubMenuOptions.includes("Logistic Party Master")) {
                return (
                    <tr key={`logistic-${index}`}>
                        <td><label htmlFor={`logistic-checkbox-${index}`}>Logistic</label></td>
                        <td>
                            <input
                                type="checkbox"
                                id="Widget_Logistic"
                                onChange={handleCheckboxChange}
                                checked={widgetDetail.Widget_Logistic === 1}
                            />
                        </td>
                    </tr>
                );
            }
            return null;
        });

        return isAdmin ? adminItems : roleBasedItems;
    };

    return (
        <>
            <ToastContainer />
            <Modal centered
                show={showModal}
                onHide={handleClose}  // Use handleClose instead of inline function
                backdrop="static"
                size="md"
            >
                <Modal.Header closeButton
                    style={{ backgroundColor: "#00A7E2" }}
                >
                    <Modal.Title style={{
                        color: "#fff",
                        fontSize: '20px',
                        fontWeight: "bold"
                    }}>
                        Widget
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="small_container">
                        {renderRoleBasedItems()}
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default Widget;